<script>
  import { onMount, onDestroy } from 'svelte';

  let { sitekey, onToken = () => {}, onExpire = () => {}, theme = 'auto' } = $props();

  const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

  let container = $state(null);
  let widgetId = null;
  let mounted = false;

  function loadScript() {
    if (window.turnstile) return Promise.resolve();
    let script = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (script && script.dataset.loaded === 'true') return Promise.resolve();

    return new Promise((resolve, reject) => {
      if (!script) {
        script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
      });
      script.addEventListener('error', reject);
    });
  }

  function render() {
    if (!mounted || !container || !window.turnstile || !sitekey) return;
    widgetId = window.turnstile.render(container, {
      sitekey,
      theme,
      callback: (token) => onToken(token),
      'expired-callback': () => {
        onExpire();
        onToken('');
      },
      'error-callback': () => onToken('')
    });
  }

  export function reset() {
    if (widgetId != null && window.turnstile) {
      window.turnstile.reset(widgetId);
    }
  }

  onMount(async () => {
    mounted = true;
    try {
      await loadScript();
      render();
    } catch (error) {
      console.error('Failed to load Turnstile:', error);
    }
  });

  onDestroy(() => {
    mounted = false;
    if (widgetId != null && window.turnstile) {
      try {
        window.turnstile.remove(widgetId);
      } catch {
        // ignore
      }
    }
  });
</script>

<div class="turnstile" bind:this={container}></div>

<style>
  .turnstile {
    display: flex;
    justify-content: center;
    min-height: 65px;
  }
</style>
